exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-group > .list-group-item .mdi[data-v-b9d27c5a] {\n  width: 25px;\n  color: #a6a6a6;\n  font-size: 1rem;\n  text-align: center;\n}\n.list-group > .list-group-item.show-more[data-v-b9d27c5a] {\n  background-color: #f5f7fa;\n}\n.list-group > .list-group-item.show-more > .btn[data-v-b9d27c5a] {\n  color: #555;\n}", ""]);

// exports
